import React from "react";
import "./App.css";
import logo from "./assets/images/wts-logo.png";

const PrivacyPolicyPage = () => {
  return (
    <div className="container">
      <a className="mb-20" href="https://www.schoolbus.solutions/">
        <img src={logo} alt="shoolbus solution" />
      </a>
      <div className="mb-20">Last Updated: 16 September 2021</div>

      <div className="bold-text text-xl ">
        Woodlands Transport Service Pte Ltd
      </div>
      <div className="mb-20">Privacy Policy & Data Protection Notice</div>

      <div className="bold-text text-xl mb-20">Legal Info</div>
      <div className="mb-15">
        At Woodlands Transport Service Pte Ltd (WTS), one of our main priorities
        is the privacy of visitors to our website(s), accessible from, but not
        limited to, HQ Bus Driver App and Company Passenger App.
      </div>
      <div className="mb-20">
        This Privacy Policy contains types of information that is collected and
        recorded and how we use it. If you have additional questions or require
        more information about our Privacy Policy, do not hesitate to contact
        us. This Privacy Policy applies only to our online activities and is
        valid for visitors to our website with regards to the information that
        they shared and/or collected in/at any of our website(s). This policy is
        not applicable to any information collected offline or via channels
        other than our website(s).
      </div>

      <div className="bold-text text-xl mb-20">Privacy Policy</div>
      <div className="mb-20">
        By using our website, you hereby consent to our Privacy Policy and agree
        to its terms.
      </div>

      <div className="bold-text text-xl mb-20">Information We Collect</div>
      <div className="mb-15">
        The personal information that you are asked to provide, and the reasons
        why you are asked to provide it, will be made clear to you at the point
        we ask you to provide your personal information.
      </div>
      <div className="mb-20">
        If you contact us directly, we may receive additional information about
        you such as your name, email address, phone number, the contents of the
        message and/or attachments you may send us, and any other information
        you may choose to provide. When you register for an Account, we may ask
        for your contact information, including items such as name, company
        name, address, email address, and telephone number.
      </div>

      <div className="bold-text text-xl mb-20">How We Use Your Information</div>
      <div className="mb-15">
        We use the information we collect in various ways, including to:
      </div>
      <div className="mb-15">Provide, operate, and maintain our website;</div>
      <div className="mb-15">Improve, personalize, and expand our website;</div>
      <div className="mb-15">
        Understand and analyze how you use our website;
      </div>
      <div className="mb-15">
        Develop new products, services, features, and functionality;
      </div>
      <div className="mb-15">
        Communicate with you, either directly or through one of our partners,
        including for customer service, to provide you with updates and other
        information relating to the website, and for marketing and promotional
        purposes;
      </div>
      <div className="mb-15">Send you emails;</div>
      <div className="mb-20">Find and prevent fraud;</div>

      <div className="bold-text text-xl mb-20">Log Files</div>
      <div className="mb-20">
        WTS follows a standard procedure of using log files. These files log
        visitors when they visit websites. All hosting companies do this and a
        part of hosting services' analytics. The information collected by log
        files include internet protocol (IP) addresses, browser type, Internet
        Service Provider (ISP), date and time stamp, referring/exit pages, and
        possibly the number of clicks. These are not linked to any information
        that is personally identifiable. The purpose of the information is for
        analyzing trends, administering the site, tracking users' movement on
        the website, and gathering demographic information.
      </div>

      <div className="bold-text text-xl mb-20">Location Information</div>
      <div className="mb-20">
        We collect and use precise location information from your device with
        your permission when you choose to use location-related features, like
        when you decide to share your location with your contacts or view
        locations nearby or locations others have shared with you. There are
        certain settings relating to location-related information which you can
        find in your device settings or the in-app settings, such as location
        sharing. Even if you do not use our location-related features, we use IP
        addresses and other information like phone number area codes to estimate
        your general location (e.g., city and country). We also use your
        location information for diagnostics and troubleshooting purposes.
      </div>

      <div className="bold-text text-xl mb-20">Cookies and Web Beacons</div>
      <div className="mb-20">
        Like any other website, WTS uses 'cookies'. These cookies are used to
        store information including visitors' preferences, and the pages on the
        website that the visitor accessed or visited. The information is used to
        optimize the users' experience by customizing our web page content based
        on visitors' browser type and/or other information.
      </div>

      <div className="bold-text text-xl mb-20">Our Advertising Partners</div>
      <div className="mb-20">
        Some of advertisers on our site may use cookies and web beacons. Our
        advertising partners are listed below. Each of our advertising partners
        has their own Privacy Policy for their policies on user data. For easier
        access, we hyperlinked to their Privacy Policies below.
      </div>

      <div className="mb-20">
        Google -{" "}
        <a href="https://policies.google.com/technologies/ads">
          https://policies.google.com/technologies/ads
        </a>
      </div>

      <div className="bold-text text-xl mb-20">
        Advertising Partners Privacy Policies
      </div>
      <div className="mb-15">
        You may consult this list to find the Privacy Policy for each of the
        advertising partners of WTS.
      </div>
      <div className="mb-15">
        Third-party ad servers or ad networks use technologies like cookies,
        JavaScript, or Web Beacons that are used in their respective
        advertisements and links that appear on WTS, which are sent directly to
        users' browsers. They automatically receive your IP address when this
        occurs. These technologies are used to measure the effectiveness of
        their advertising campaigns and/or to personalize the advertising
        content that you see on websites that you visit.
      </div>
      <div className="mb-20">
        Note that WTS has no access to or control over these cookies that are
        used by third-party advertisers.
      </div>

      <div className="bold-text text-xl mb-20">
        Third Party Privacy Policies
      </div>
      <div className="mb-15">
        WTS's Privacy Policy does not apply to other advertisers or websites.
        Thus, we are advising you to consult the respective Privacy Policies of
        these third-party ad servers for more detailed information. It may
        include their practices and instructions about how to opt-out of certain
        options.
      </div>
      <div className="mb-20">
        You can choose to disable cookies through your individual browser
        options. To know more detailed information about cookie management with
        specific web browsers, it can be found at the browsers' respective
        websites.
      </div>

      <div className="bold-text text-xl mb-20">Data Protection Notice</div>

      <div className="bold-text text-xl mb-20">
        DATA PROTECTION NOTICE FOR CUSTOMERS
      </div>
      <div className="mb-15">
        This Data Protection Notice (“Notice”) sets out the basis which
        Woodlands Transport Solutions Pte Ltd (“we”, “us”, or “our”) may
        collect, use, disclose or otherwise process personal data of our
        customers in accordance with the Personal Data Protection Act (“PDPA”).
        This Notice applies to personal data in our possession or under our
        control, including personal data in the possession of organisations
        which we have engaged to collect, use, disclose or process personal data
        for our purposes.
      </div>

      <div className="bold-text text-xl mb-20">PERSONAL DATA</div>
      <div className="mb-15">As used in this Notice:</div>
      <div className="mb-15">
        “customer” means an individual who (a) has contacted us through any
        means to find out more about any goods or services we provide, or (b)
        may, or has, entered into a contract with us for the supply of any goods
        or services by us; and
      </div>
      <div className="mb-15">
        “personal data” means data, whether true or not, about a customer who
        can be identified: (a) from that data; or (b) from that data and other
        information to which we have or are likely to have access.
      </div>
      <div className="mb-15">
        Depending on the nature of your interaction with us, some examples of
        personal data which we may collect from you include name, identification
        numbers such as nric, fin, work permit and birth certificate,
        residential address, email address, telephone number, nationality,
        gender, date of birth, employment information and financial information.
      </div>
      <div className="mb-20">
        Other terms used in this Notice shall have the meanings given to them in
        the PDPA (where the context so permits).
      </div>

      <div className="bold-text text-xl mb-20">
        COLLECTION, USE AND DISCLOSURE OF PERSONAL DATA
      </div>
      <div className="mb-15">
        We generally do not collect your personal data unless (a) it is provided
        to us voluntarily by you directly or via a third party who has been duly
        authorised by you to disclose your personal data to us (your “authorised
        representative”) after (i) you (or your authorised representative) have
        been notified of the purposes for which the data is collected, and (ii)
        you (or your authorised representative) have provided written consent to
        the collection and usage of your personal data for those purposes, or
        (b) collection and use of personal data without consent is permitted or
        required by the PDPA or other laws. We shall seek your consent before
        collecting any additional personal data and before using your personal
        data for a purpose which has not been notified to you (except where
        permitted or authorised by law).
      </div>
      <div className="mb-15">
        We may collect and use your personal data for any or all of the
        following purposes:
      </div>
      <div className="mb-15">
        performing obligations in the course of or in connection with our
        provision of the goods and/or services requested by you;
      </div>
      <div className="mb-15">verifying your identity;</div>
      <div className="mb-15">
        responding to, handling, and processing queries, requests, applications,
        complaints, and feedback from you;
      </div>
      <div className="mb-15">managing your relationship with us;</div>
      <div className="mb-15">processing payment or credit transactions;</div>
      <div className="mb-15">
        complying with any applicable laws, regulations, codes of practice,
        guidelines, or rules, or to assist in law enforcement and investigations
        conducted by any governmental and/or regulatory authority;
      </div>
      <div className="mb-15">
        any other purposes for which you have provided the information;
      </div>
      <div className="mb-15">
        transmitting to any unaffiliated third parties including our third party
        service providers and agents, and relevant governmental and/or
        regulatory authorities, whether in Singapore or abroad, for the
        aforementioned purposes; and
      </div>
      <div className="mb-15">
        any other incidental business purposes related to or in connection with
        the above.
      </div>
      <div className="mb-15">We may disclose your personal data:</div>
      <div className="mb-15">
        where such disclosure is required for performing obligations in the
        course of or in connection with our provision of the goods and services
        requested by you; or
      </div>
      <div className="mb-15">
        to third party service providers, agents and other organisations we have
        engaged to perform any of the functions with reference to the above
        mentioned purposes.
      </div>
      <div className="mb-20">
        The purposes listed in the above clauses may continue to apply even in
        situations where your relationship with us (for example, pursuant to
        your employment contract should you be hired) has been terminated or
        altered in any way, for a reasonable period thereafter (including, where
        applicable, a period to enable us to enforce our rights under a contract
        with you).
      </div>

      <div className="bold-text text-xl mb-20">WITHDRAWING YOUR CONSENT</div>
      <div className="mb-15">
        The consent that you provide for the collection, use and disclosure of
        your personal data will remain valid until such time it is being
        withdrawn by you in writing. You may withdraw consent and request us to
        stop collecting, using and/or disclosing your personal data for any or
        all of the purposes listed above by submitting your request in writing
        or via email to our Data Protection Officer at the contact details
        provided below.
      </div>
      <div className="mb-15">
        Upon receipt of your written request to withdraw your consent, we may
        require reasonable time (depending on the complexity of the request and
        its impact on our relationship with you) for your request to be
        processed and for us to notify you of the consequences of us acceding to
        the same, including any legal consequences which may affect your rights
        and liabilities to us. In general, we shall seek to process your request
        within fourteen (14) business days of receiving it.
      </div>
      <div className="mb-15">
        Whilst we respect your decision to withdraw your consent, please note
        that depending on the nature and scope of your request, we may not be in
        a position to continue providing our goods or services to you and we
        shall, in such circumstances, notify you before completing the
        processing of your request. Should you decide to cancel your withdrawal
        of consent, please inform us in writing in the manner described in
        clause 7 above.
      </div>
      <div className="mb-20">
        Please note that withdrawing consent does not affect our right to
        continue to collect, use and disclose personal data where such
        collection, use and disclosed without consent is permitted or required
        under applicable laws.
      </div>

      <div className="bold-text text-xl mb-20">
        ACCESS TO AND CORRECTION OF PERSONAL DATA
      </div>
      <div className="mb-15">
        If you wish to make (a) an access request for access to a copy of the
        personal data which we hold about you or information about the ways in
        which we use or disclose your personal data, or (b) a correction request
        to correct or update any of your personal data which we hold about you,
        you may submit your request in writing or via email to our Data
        Protection Officer at the contact details provided below.
      </div>
      <div className="mb-15">
        Please note that a reasonable fee may be charged for an access request.
        If so, we will inform you of the fee before processing your request.
      </div>
      <div className="mb-20">
        We will respond to your request as soon as reasonably possible. In
        general, our response will be within fourteen (14) business days. Should
        we not be able to respond to your request within thirty (30) days after
        receiving your request, we will inform you in writing within thirty (30)
        days of the time by which we will be able to respond to your request. If
        we are unable to provide you with any personal data or to make a
        correction requested by you, we shall generally inform you of the
        reasons why we are unable to do so (except where we are not required to
        do so under the PDPA).
      </div>

      <div className="bold-text text-xl mb-20">PROTECTION OF PERSONAL DATA</div>
      <div className="mb-15">
        To safeguard your personal data from unauthorised access, collection,
        use, disclosure, copying, modification, disposal or similar risks, we
        have introduced appropriate administrative, physical and technical
        measures such as encryption, and disclosing personal data both
        internally and to our authorised third party service providers and
        agents only on a need-to-know basis.
      </div>
      <div className="mb-20">
        You should be aware, however, that no method of transmission over the
        Internet or method of electronic storage is completely secure. While
        security cannot be guaranteed, we strive to protect the security of your
        information and are constantly reviewing and enhancing our information
        security measures.
      </div>

      <div className="bold-text text-xl mb-20">ACCURACY OF PERSONAL DATA</div>
      <div className="mb-20">
        We generally rely on personal data provided by you (or your authorised
        representative). In order to ensure that your personal data is current,
        complete and accurate, please update us if there are changes to your
        personal data by informing our Data Protection Officer in writing or via
        email at the contact details provided below.
      </div>

      <div className="bold-text text-xl mb-20">RETENTION OF PERSONAL DATA</div>
      <div className="mb-15">
        We may retain your personal data for as long as it is necessary to
        fulfil the purpose for which it was collected, or as required or
        permitted by applicable laws.
      </div>
      <div className="mb-20">
        We will cease to retain your personal data, or remove the means by which
        the data can be associated with you, as soon as it is reasonable to
        assume that such retention no longer serves the purpose for which the
        personal data was collected, and is no longer necessary for legal or
        business purposes.
      </div>

      <div className="bold-text text-xl mb-20">RETENTION OF PERSONAL DATA</div>
      <div className="mb-20">
        We generally do not transfer your personal data to countries outside of
        Singapore. However, if we do so, we will obtain your consent for the
        transfer to be made and we will take steps to ensure that your personal
        data continues to receive a standard of protection that is at least
        comparable to that provided under the PDPA.
      </div>

      <div className="bold-text text-xl mb-20">DATA PROTECTION OFFICER</div>
      <div className="mb-15">
        You may contact our Data Protection Officer if you have any enquiries or
        feedback on our personal data protection policies and procedures, or if
        you wish to make any request, in the following manner:
      </div>
      <table className="mb-20">
        <tr>
          <td>Name of DPO:</td>
          <td>Brighton</td>
        </tr>
        <tr>
          <td>Contact No:</td>
          <td>9116 3297</td>
        </tr>
        <tr>
          <td>Email Address:</td>
          <td>brightonyam@woodlandstransport.com.sg</td>
        </tr>
      </table>

      <div className="bold-text text-xl mb-20">
        EFFECT OF NOTICE AND CHANGES TO NOTICE
      </div>
      <div className="mb-15">
        This Notice applies in conjunction with any other notices, contractual
        clauses and consent clauses that apply in relation to the collection,
        use and disclosure of your personal data by us.
      </div>
      <div className="mb-20">
        We may revise this Notice from time to time without any prior notice.
        You may determine if any such revision has taken place by referring to
        the date on which this Notice was last updated. Your continued use of
        our services constitutes your acknowledgement and acceptance of such
        changes.
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
